export default {
    'invalid_credentials': 'Ongeldige logingegevens. Probeer het opnieuw',
    'invalid_token': 'Ongeldige token. Registreer het apparaat opnieuw',
    'not_authorized': 'U bent niet geautoriseerd om deze pagina te bekijken',
    'user_not_found': 'Kan de gevraagde gebruiker niet vinden',
    'unknown_pincode': 'Onbekende pincode',
    'workday_not_found': 'Werkdag niet gevonden',
    'no_activity': 'U hebt geen openstaande activiteit',
    'unfinished_activity': 'U hebt een openstaande activiteit. Maak deze eerst af',
    'row_not_found': 'Kon de gevraagde rij niet vinden. Kies een andere rij.',
    'team_not_found': 'Kon het gevraagde team niet vinden. Kies een ander team.',
    'invalid_device_name': 'De gekozen naam is al in gebruik. Kies een andere naam.',
    'not_a_client': 'U kunt alleen inloggen met een klant account'
};
